// S ::::: KPOP 지도자 자격증 ::::: S
export const kpopLists = [
  {
    title: "KPOP 지도자 자격증 2급",
    texts: ["8주 교육과정", "교육과정 이수 후 자격검정 응시"],
    targets: [
      "IPDIA 본부센터 또는 지부 수업 8개월 이상 수강자",
      "IPDIA 전문 자격증 취득자",
      "타 댄스 자격증 소지자 또는 댄스 관련 종사자",
      "댄스 1년 이상 경력",
    ],
    curriculums: [
      "KPOP 강의 시 필요한 역량 트레이닝",
      "프로 댄서를 목표로 하는 실전 중심 교육",
      "댄스에 대한 필수 소양 및 이해",
      "강의법 교육 및 훈련",
      "IPDIA 자격 취득자 교육 워크샵 참여권한 부여",
    ],
    goals: [
      "KPOP 댄스 지도자 강의 자격 부여",
      "전문적인 댄스 지식 및 실력 향상",
      "연령 제한 없는 지도자 양성",
    ],
  },
];
// E ::::: KPOP 지도자 자격증 ::::: E
